import { ArchiveStarIcon } from './ArchiveStarIcon';

/**
 * author: Colton Wiscombe
 * id 08484938-1011-46B2-9756-2C227B9BCAAC
 * name archive-star
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-star.svg
 * tags
 */
export const ArchiveFavoriteIcon = ArchiveStarIcon;
export default ArchiveFavoriteIcon